(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !window.DesignMode) return;
  try {
    

var beforeAfterSlider = () => {
    console.log('beforeAfterSlider')
    var BASwiperSettings = {
        slidesPerView: 1.5,
        spaceBetween: 20,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        freeMode: true,
        breakpoints: {
            768: {
                slidesPerView: 3,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
            }
        }
    }
    var swiper = new Swiper('.before-after__modules', BASwiperSettings);
}

var resizeSliders = () => {
    document.querySelectorAll('.before-after__module').forEach(function(module, index) {
        const width = module.offsetWidth;
        module.querySelector('.before-after__before img').style.width = width + 'px';
    });
}
    
var current;
['pointerdown', 'touchstart'].forEach(function(event) {
        document.querySelectorAll('.before-after__resize').forEach(function(elem) {
            elem.addEventListener(event, function(e) {
                // Prevent clicks on resizer from moving the swiper slide
                e.stopPropagation();
                current = e.target.closest('.before-after__module');
            });
        });
});

['pointerup', 'mouseleave', 'touchend', 'touchcancel'].forEach(function(event) {
    document.addEventListener(event, function(e) {
        current = null;
    });
});

document.body.addEventListener('pointermove', function(e) {
    if (!current) return;
    let x = e.pageX;
    x -= current.getBoundingClientRect().left;
    let transform = Math.max(0,(Math.min(x,current.offsetWidth)));
    const before = current.querySelector('.before-after__before');
    const resizer = current.querySelector('.before-after__resize');
    before.style.width = transform+"px";
    resizer.style.left = transform-0+"px";
});

window.addEventListener('searchspring-recs-loaded', () => {
    console.log('start:searchspring-recs-loaded triggered');
    beforeAfterSlider();
    resizeSliders();
})

window.addEventListener('resize', resizeSliders);

document.addEventListener('DOMContentLoaded', function() {
    beforeAfterSlider();
    resizeSliders();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-page"] && !window.DesignMode) return;
  try {
    
    // Add your custom scripts here
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
const mobileMenu = document.querySelector('.mobile-menu');
const mobileMenuButton = document.querySelector('.header-mobile-menu');

mobileMenuButton.addEventListener('click', function() {
  console.log('clicking on .header-mobile-menu')
  document.body.classList.toggle('mobile-menu-opened');
});

const closeMobileMenu = function(){
  document.body.classList.remove('mobile-menu-opened');
}

document.addEventListener('click', function(event) {

  const menuItem = event.target.closest('.menu-item.level-1.with--dropdown');  
  if (event.target.classList.contains('level-1') && event.target.classList.contains('with--dropdown') ) {
    event.preventDefault();
    const menuItemLink = menuItem.querySelector('.menu-item-link');

    if (mobileMenu) {
      mobileMenu.classList.add('slide-menu-opened');
    }

    if (menuItemLink) {
      const dataTriggerValue = menuItemLink.getAttribute('data-trigger');
      console.log('dataTriggerValue', dataTriggerValue);
      if (dataTriggerValue) {
        const targetSlideMenu = mobileMenu.querySelector(`.slide-in-menu [data-target="${dataTriggerValue}"]`);
        if (targetSlideMenu) {
            const siblingSlideMenus = mobileMenu.querySelectorAll('.slide-in-menu .dropdown');
            siblingSlideMenus.forEach(sibling => {
                sibling.classList.remove('active');
            });

            targetSlideMenu.classList.add('active');
        }
      }
    }
  }

  const backButton = event.target.closest('.back-to');
  if (backButton) {
    backButton.parentElement.classList.remove('active');
    if (mobileMenu) {
      mobileMenu.classList.remove('slide-menu-opened');
    }
  }

  const menu2Item = event.target.closest('.menu-item.level-2.with--dropdown');
  if (event.target.classList.contains('level-2') && event.target.classList.contains('with--dropdown') ) {
    event.preventDefault();
    menu2Item.classList.toggle('active');
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-before-after"] && !window.DesignMode) return;
  try {
    
    
    var beforeAfterSlider = () => {
        console.log('beforeAfterSlider')
        var BASwiperSettings = {
            slidesPerView: 1.5,
            spaceBetween: 20,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
            freeMode: true,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                }
            }
        }
        var swiper = new Swiper('.before-after__modules', BASwiperSettings);
    }
    
    var resizeSliders = () => {
        document.querySelectorAll('.before-after__module').forEach(function(module, index) {
            const width = module.offsetWidth;
            module.querySelector('.before-after__before img').style.width = width + 'px';
        });
    }
        
    var current;
    ['pointerdown', 'touchstart'].forEach(function(event) {
            document.querySelectorAll('.before-after__resize').forEach(function(elem) {
                elem.addEventListener(event, function(e) {
                    // Prevent clicks on resizer from moving the swiper slide
                    e.stopPropagation();
                    current = e.target.closest('.before-after__module');
                });
            });
    });
    
    ['pointerup', 'mouseleave', 'touchend', 'touchcancel'].forEach(function(event) {
        document.addEventListener(event, function(e) {
            current = null;
        });
    });
    
    document.body.addEventListener('pointermove', function(e) {
        if (!current) return;
        let x = e.pageX;
        x -= current.getBoundingClientRect().left;
        let transform = Math.max(0,(Math.min(x,current.offsetWidth)));
        const before = current.querySelector('.before-after__before');
        const resizer = current.querySelector('.before-after__resize');
        before.style.width = transform+"px";
        resizer.style.left = transform-0+"px";
    });
    
    window.addEventListener('searchspring-recs-loaded', () => {
        console.log('start:searchspring-recs-loaded triggered');
        beforeAfterSlider();
        resizeSliders();
    })
    
    window.addEventListener('resize', resizeSliders);
    
    document.addEventListener('DOMContentLoaded', function() {
        beforeAfterSlider();
        resizeSliders();
    });
    
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-you-may-also-like-23"] && !window.DesignMode) return;
  try {
    
  var handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }

        initProductRecSwiper();
      })
      .catch(e => {
        console.error(e);
      });
  };

  var productRecommendationsSection = document.querySelector('.product-recommendations');
  var observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  function initProductRecSwiper(){
    productRecSwiper = new Swiper(".product-recommendations.swiper", {
      slidesPerView: 2.25,
      spaceBetween: 10,
      // slidesOffsetBefore: getMobilePadding(),
      // slidesOffsetAfter: getMobilePadding(),
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1024: {
          slidesPerView: 5,
          spaceBetween: 20,
          loop: false
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["step-by-step-video-tabs"] && !window.DesignMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
    const tabTriggers = document.querySelectorAll('.tab-trigger');
    const videos = document.querySelectorAll('.tab__video');
    const tabSwiper = new Swiper('.step-by-step-video-tabs .tabs', {
        speed: 400,
        effect: "fade",
        fadeEffect: { crossFade: true },
    });


    tabTriggers.forEach((tabTrigger, index) => {
        tabTrigger.addEventListener('click', function() {
            tabSwiper.slideTo(index);

            tabTriggers.forEach((tabTrigger) => {
                tabTrigger.classList.remove('tab-trigger--active');
            });
            tabTrigger.classList.add('tab-trigger--active');
        })
    })

    videos.forEach((video) => {
        const videoPlayer = video.querySelector('.video__player');
        const videoPlayButton = video.querySelector('.controls__play-icon');
        const videoPauseButton = video.querySelector('.controls__pause-icon');

        videoPlayButton.addEventListener('click', function() {
            videoPlayer.play();
            video.classList.add('tab__video--playing');
        })

        videoPauseButton.addEventListener('click', function() {
            videoPlayer.pause();
            video.classList.remove('tab__video--playing');
        })
    })
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vqb-results"]) return;
  try {
    
  const mainProduct = document.getElementById("main-product");
  const mainProductAnswers = document.querySelector('.quiz-info-answers')
  const mainProductCta = document.querySelector('.quiz-info-cta')
  const additionalShades = document.getElementById("additional-shades");
  const toolsAccessories = document.getElementById("tools-accessories");

  // Pull URL query parameters
  const paramsString = window.location.search;
  const searchParams = new URLSearchParams(window.location.search);

  // Storing product recommendations in another global variable
  const slotProducts = JSON.parse(searchParams.get('slot-products'));
  const additionalShadesProductHandles = slotProducts.find(slot => slot.name.toLowerCase() === 'additional-shades')?.products.split(',');
  const toolsAccessoriesProductHandles = searchParams.get('upsell_products').split(',');
  const additionalShadesProducts = [];
  const toolsAccessoriesProducts = [];
  const displayedAnswersLimit = 3;
  const quizAnswers = {};
  quizAnswers.tryingToAchieve = searchParams.get('trying_to_achieve') || "";
  quizAnswers.hairLength = searchParams.get('hair_length') || "";
  quizAnswers.hairThickness = searchParams.get('hair_thickness') || "";
  quizAnswers.desiredVolume = searchParams.get('desired_volume') || "";
  quizAnswers.desiredCoverage = searchParams.get('desired_coverage') || "";
  quizAnswers.preferredPieceCount = searchParams.get('preferred_piece_count') || "";
  quizAnswers.thinningLocation = searchParams.get('thinning_location') || "";
  quizAnswers.volumeBangs = searchParams.get('volume_bangs') || "";
  quizAnswers.hairColor = searchParams.get('hair_color') || "";

  let displayedAnswersCount = 0;
  for (const [question, answer] of Object.entries(quizAnswers)) {
    if (displayedAnswersCount >= displayedAnswersLimit) break;

    if (answer) {
      const answerElement = document.createElement('li');
      answerElement.innerHTML = `Because you answered <span class="answer">${answer}</span>`;

      mainProductAnswers.appendChild(answerElement);
      displayedAnswersCount++;
    }
  }

  function populateRecommendedProductSection(productHandles, slotHandle) {
    Promise.all(productHandles.map(function (product) {
      return new Promise(function (resolve, reject) {
        fetch('/products/' + product + '.json')
        .then(function(result) {
          // Making sure that the product actually exists
          if (result.status !== 404) {
            return result.json()
          } else {
            return { product: null }
          }
        })
        .then(function(data) {
          resolve(data.product)
        })
        .catch(reject)
      })
    }))
    .then(function(data) {
      // Filtering out the products list if it had any removed products
      data = data.filter(function (product) { return !!product });

      const productCardTemplate = function(product) {
        return `
          <div class="product-card">
            ${product.images.length ? `
              <a href="/products/${product.handle}" itemprop="url">
                <img class="card-image" src="${product.images[0].src}" alt="${product.title}" />
              </a>` : ""}
            <div class="card-info">
              <p class="card-title">
                <a href="/products/${product.handle}" itemprop="url">${product.title}</a>
              </p>
              ${product.color ? `
                <p class="card-color">${product.color}</p>` : ""
              }
              <p class="card-price" itemprop="offers" itemscope itemtype="http://schema.org/Offer">
                <meta itemprop="price" content="${product.variants[0].price}" />
                <meta itemprop="priceCurrency" content="USD" />
                <link itemprop="availability" href="http://schema.org/InStock">
                <span class="money">$${product.variants[0].price}</span>
              </p>
            </div>
          </div>
        `
      };

      data.forEach((product, index) => {
        const productColorTag = product.tags.split?.(',').find?.(tag => tag.includes('Color:'));

        if (productColorTag) {
          product.color = productColorTag.split?.(':')[1].trim?.();
        }

        const productCard = new DOMParser().parseFromString(productCardTemplate(product), "text/html").body.firstChild;

        if (slotHandle === 'additional-shades') {
          if (index === 0) { // Use the first result as the "Main Product"
            mainProduct.appendChild(productCard);
            mainProductCta.href = `/products/${product.handle}`
          } else {
            additionalShades.appendChild(productCard);
          }
        } else if (slotHandle === 'tools-accessories') {
          toolsAccessories.appendChild(productCard);
        }
      })
    }) 
  }

  populateRecommendedProductSection(additionalShadesProductHandles, 'additional-shades');
  populateRecommendedProductSection(toolsAccessoriesProductHandles, 'tools-accessories');

  } catch(e) { console.error(e); }
})();
})();
